export default "https://d1e6s5z4lzmgxx.cloudfront.net/ba82fc54-f5ca-4442-8850-d050cbc89c21/images/fortisimo-icon.svg?cd52fbd6408a9f4f0b25374cad804a27";